import { Button, CircularProgress, Dialog, DialogActions, DialogContent, DialogTitle, Grid, TextField } from "@mui/material";
import { IDataDetalharTitulosReceber, Publico } from "../../../../../../../types/api/financeiro/datalhar-titulos-receber";
import { useState } from "react";
import SelectCategoria from "../../../../../../../components/SelectsSimpleApiQuery/SelectCategoria";
import SelectLocaisCobranca from "../../../../../../../components/SelectsSimpleApiQuery/SelectLocaisCobranca";
import SelectSituacaoFinanceira from "../../../../../../../components/SelectsSimpleApiQuery/SelectSituacaoFinanceira";
import PaperDraggable from "../../../../../../../components/PaperDraggable";
import { useMutation, useQueryClient } from "react-query";
import axiosClient from "../../../../../../../lib/axios";
import { enqueueSnackbar } from "notistack";
import { TSituacaoFinanceira } from "../../../../../../../types/api/financeiro/situacao-financeira";
import { TLocalCobranca } from "../../../../../../../types/api/financeiro/pesquisar-locais-cobranca";
import { TCategoriaFinanceiro } from "../../../../../../../types/api/financeiro/categorias-financeiro";
import SelectPublico from "../../../../../../../components/SelectsSimpleApiQuery/SelectPublico";
import SelectFuncoes from "../../../../../../../components/SelectsSimpleApiQuery/SelectFuncao";
import SelectFazenda from "../../../../../../../components/SelectsSimpleApiQuery/SelectFazendas";
import SelectTipoDocReceber from "../../../../../../../components/SelectsSimpleApiQuery/SelectTipoDocReceber";
import SelectDepartamentoFinanceiro from "../../../../../../../components/SelectsSimpleApiQuery/SelectDepartamentoFinanceiro";
import { IDataDepartamentosFinanceiros } from "../../../../../../../types/api/financeiro/pesquisar-departamentos-financeiros";

export default function DialogEdit({
    open,
    handleClose,
    titulo,
    codigo
}: DialogEditProps) {

    const queryClient = useQueryClient();

    const [internFilters, setInternFilters] = useState<TInternFilters>({
        publico: titulo.publico,
        fazenda: titulo.fazenda ? { apelido: titulo.fazenda.apelido, nome: titulo.fazenda.nome } : null,
        tipo: titulo.tipo ? { id: titulo.tipo.codigo, nome: titulo.tipo.nome } : null,
        categoria: titulo.categoria,
        situacao: titulo.situacao,
        departamento: titulo.departamento,
        funcao: titulo.funcao,
        local_cobranca: titulo.local_cobranca,
        comprador: titulo.comprador,
        objeto: titulo.objeto,
        historico: titulo.historico
    })

    const { mutate: atualizarTitulo, isLoading } = useMutation({
        mutationKey: 'atualizar-titulo-receber',
        mutationFn: (input: any) => axiosClient.put(`financeiro/contas-receber/atualizar-titulo-receber`, input),
        onError: (error) => {
            console.error(error);
            enqueueSnackbar(`Erro ao atualizar título`, { variant: "error" })
        },
        onSuccess: ({ data }) => {
            queryClient.invalidateQueries("financeiro/contas-receber/detalhar-titulo-receber")
            queryClient.invalidateQueries("table-data-grid-financeiro/contas-receber/pesquisar-titulos-receber")
            enqueueSnackbar(`Título atualizado com sucesso!`, { variant: "success" })
            handleClose()
        }
    });

    const handleChangeInputs = (prop: keyof TInternFilters, value: any) => {
        let param = value
        if (prop === 'publico') param = {
            tipo_publico: value.tipo_publico,
            codigo_publico: value.codigo_publico,
            nome_pessoa: value.nome_pessoa
        }
        setInternFilters(prevState => ({ ...prevState, [prop]: param }))
    }

    const handleSubmit = () => {
        const params = {
            id_titulo: codigo,
            tipo_publico_selecionado: internFilters.publico.tipo_publico,
            codigo_publico_selecionado: internFilters.publico.codigo_publico,
            tipo_publico: titulo.publico.tipo_publico,
            codigo_publico: titulo.publico.codigo_publico,
            categoria_id: internFilters.categoria.id,
            situacao_id: internFilters.situacao.id,
            departamento_id: internFilters.departamento.id,
            local_cobranca_id: internFilters.local_cobranca.codigo,
            objeto: internFilters.objeto ?? '',
            historico: internFilters.historico ?? '',
            ...(internFilters.fazenda ? { fazenda_id: internFilters.fazenda.apelido } : {})
        }
        atualizarTitulo(params)
    }

    return (
        <Dialog
            open={open}
            onClose={handleClose}
            PaperComponent={PaperDraggable}
            aria-labelledby="draggable-dialog-title"
            fullWidth
            maxWidth={"md"}
            scroll="body"
        >
            <DialogTitle style={{ cursor: 'move', paddingBottom: 0 }} id="draggable-dialog-title">Editar título</DialogTitle>

            <DialogContent>
                <Grid container spacing={2} pt={3}>
                    <Grid size={{ xs: 6 }}>
                        <SelectPublico
                            value={internFilters.publico as any}
                            onChange={(valor) => handleChangeInputs("publico", valor)}
                        />
                    </Grid>

                    <Grid size={{ xs: 6 }}>
                        <SelectFazenda
                            codigo={Number(internFilters.publico.codigo_publico)}
                            tipo={internFilters.publico.tipo_publico}
                            value={internFilters.fazenda as any}
                            onChange={(valor) => handleChangeInputs("fazenda", valor)}
                        />
                    </Grid>

                    <Grid size={{ xs: 6 }}>
                        <SelectTipoDocReceber
                            required
                            value={internFilters.tipo as any}
                            onChange={(valor) => handleChangeInputs("tipo", valor)}
                        />
                    </Grid>

                    <Grid size={{ xs: 6 }}>
                        <SelectDepartamentoFinanceiro
                            value={internFilters.departamento}
                            onChange={(valor) => handleChangeInputs("departamento", valor)}
                        />
                    </Grid>

                    <Grid size={{ xs: 6 }}>
                        <SelectFuncoes
                            value={internFilters.funcao as any}
                            onChange={(valor) => handleChangeInputs("funcao", valor)}
                        />
                    </Grid>

                    <Grid size={{ xs: 6 }}>
                        <SelectCategoria
                            value={internFilters.categoria}
                            onChange={(valor) => handleChangeInputs("categoria", valor)}
                        />
                    </Grid>

                    <Grid size={{ xs: 6 }}>
                        <SelectLocaisCobranca
                            value={internFilters.local_cobranca}
                            onChange={(valor) => {
                                handleChangeInputs("local_cobranca", valor);
                            }}
                        />
                    </Grid>

                    <Grid size={{ xs: 6 }}>
                        <SelectSituacaoFinanceira
                            value={internFilters.situacao}
                            onChange={(valor) => {
                                handleChangeInputs("situacao", valor);
                            }}
                        />
                    </Grid>

                    <Grid size={{ xs: 6 }}>
                        <TextField
                            label="Objeto"
                            fullWidth
                            value={internFilters.objeto}
                            onChange={(e) => {
                                handleChangeInputs("objeto", e.target.value.trimStart());
                            }}
                            slotProps={{ htmlInput: { maxLength: 20 } }}
                        />
                    </Grid>
                    <Grid size={{ xs: 6 }}>
                        <TextField
                            label="Histórico"
                            fullWidth
                            value={internFilters.historico}
                            onChange={(e) => {
                                handleChangeInputs("historico", e.target.value.trimStart());
                            }}
                            slotProps={{ htmlInput: { maxLength: 30 } }}
                        />
                    </Grid>



                    {/* <Grid size={{xs: 6}}>
                        <SelectContaContabil
                            value={internFilters.conta_contabil}
                            onChange={(valor) => {
                                handleChangeInputs("conta_contabil", valor);
                            }}
                        />
                    </Grid>

                    <Grid size={{xs: 6}}>
                        <SelectContraPartida
                            value={internFilters.contra_partida}
                            onChange={(valor) => {
                                handleChangeInputs("contra_partida", valor);
                            }}
                        />
                    </Grid> */}
                </Grid>
            </DialogContent>
            <DialogActions>
                <Button onClick={handleClose}>Cancelar</Button>
                <Button disabled={isLoading} variant="contained" onClick={() => handleSubmit()}>
                    {
                        (isLoading) &&
                        <CircularProgress size={20} sx={{ marginRight: 1 }} />
                    }
                    Editar
                </Button>
            </DialogActions>
        </Dialog>
    )
}

interface DialogEditProps {
    open: boolean;
    handleClose: () => void;
    titulo: IDataDetalharTitulosReceber
    codigo: string
}

type TInternFilters = {
    publico: Publico,
    fazenda: { apelido: number, nome: string } | null,
    tipo: { id: string, nome: string } | null,
    categoria: TCategoriaFinanceiro,
    situacao: TSituacaoFinanceira,
    departamento: IDataDepartamentosFinanceiros,
    funcao: { id: number, nome: string },
    local_cobranca: TLocalCobranca,
    comprador: string,
    objeto: string,
    historico: string,
}